import type { Component } from "vue";

// Templates manager: template CRUD is gated by listingControl on the backend
// (productContentTemplate bulk), with reads/templateType under productEditor.
export const routes = [
  {
    path: "/rich-content/manage",
    name: "rich-content-manager",
    component: (): Promise<Component> => import("./views/RichContentManager.vue"),
    meta: {
      requiresAuth: true,
      requiredRoles: ["listingControl"],
      requiredGroups: [],
    },
  },
  {
    path: "/rich-content/blocks",
    name: "rich-content-blocks",
    component: (): Promise<Component> => import("./views/RichContentBlocksManager.vue"),
    meta: {
      requiresAuth: true,
      // Block CRUD is gated by productEditor; the blockType dropdown by masterAccess.
      requiredRoles: ["productEditor"],
      requiredGroups: [],
    },
  },
];
